import * as React from 'react';
import { Caps } from '../ui';

export interface InputProps {
  autoFocus?: boolean;
  className?: string;
  value?: any;
  defaultValue?: any;
  /** HTML id */
  id?: string;
  label?: string;
  hasError?: boolean;
  name?: string;
  /**
   * Valid HTML input type
   * @default text
   */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  type?: string;
  wrapperClassName?: string;
  placeholder?: string;
  pattern?: string;
  disabled?: boolean;
  'data-testid'?: string;
}

const Input: React.FC<InputProps> = ({
  className = '',
  id,
  hasError = false,
  type = 'text',
  label,
  wrapperClassName,
  disabled = false,
  ...rest
}) => (
  <label htmlFor={id} className={`db ${wrapperClassName}`}>
    {label && <Caps className="dib fw5 light-tan mb3">{label}</Caps>}
    <input
      id={id}
      className={`input ba ${hasError ? 'b--blue' : 'b--transparent'} ${className}`}
      type={type}
      disabled={disabled}
      {...rest}
    />
  </label>
);

export default Input;
